import { Link, useNavigate } from 'react-router-dom';
import Button from '../shared/buttons/button';
import OrderItemsTable from './order-items-table';
import Code from './code';
import Segment from '../shared/segment';
import NavLink from '../shared/buttons/nav-link';
import { OrderType } from '../../api/order';
import { useCreatePaymentMutation } from '../../hooks/react-query/use-payment';
import { usePayOrderFromCreditMutation } from '../../hooks/react-query/use-order';

export type OrderPropsType = { order: OrderType };

function Order({ order }: OrderPropsType) {
  const navigate = useNavigate();
  const { mutateAsync: createPayment } = useCreatePaymentMutation();
  const { mutate: payOrderFromCredit } = usePayOrderFromCreditMutation();

  const handleConfirm = async () => {
    const { url } = await createPayment({ order: order.id });
    window.location.assign(url);
  };

  const handlePayFromCredit = () => {
    payOrderFromCredit({ orderId: order.id });
  };

  if (order.status) {
    return (
      <Segment noMargin textAlign='center' className='my-6'>
        <p>
          <span>بسته‌های انتخاب شده </span>
          <span className='font-medium'>خریداری شده است</span>
          <span>، با رفتن به صفحه </span>
          <a>
            <Link to='/exams'>
              <span className='font-medium text-blue-900'>آزمون‌ها</span>
            </Link>
          </a>
          <span> می توانید از آن‌ها استفاه نمایید.</span>
        </p>
        <NavLink to='/exams' color='blue' content='آزمون‌ها' className='my-4 mx-auto' />
        <NavLink to='/store' color='green' content='بازگشت به فروشگاه' className='my-4 mx-auto' />
      </Segment>
    );
  }
  return (
    <Segment noMargin className='mt-6'>
      <OrderItemsTable
        orderItems={order.orderItems}
        code={order.code}
        totalPrice={order.price}
        paymentPrice={order.paymentPrice}
        creditPrice={order.creditPrice}
      />
      <Code orderId={order.id} codeText={order.code?.text || ''} />
      {order.paymentPrice === order.creditPrice ? (
        <>
          <p>
            <span>با فشردن دکمه </span>
            <span className='font-medium'>سبز رنگ</span>
            <span> زیر با پرداخت مبلغ </span>
            <span className='font-bold'>{order.creditPrice.toLocaleString()} ریال</span>
            <span> از اعتبار خود می‌توانید از بسته های انتخاب شده استفاده کنید.</span>
          </p>
          <Button
            color='green'
            colorWeight={400}
            content='پرداخت از اعتبار'
            onClick={handlePayFromCredit}
            className='mx-auto my-2'
          />
        </>
      ) : (
        <>
          <p>
            <span>با فشردن دکمه </span>
            <span className='font-medium'>سبز رنگ</span>
            <span> زیر به درگاه پرداخت متصل میشوید و با افزایش اعتبار حساب خود به مبلغ </span>
            <span className='font-bold'>
              {(order.paymentPrice - order.creditPrice).toLocaleString()} ریال
            </span>
            <span> ، پس از برگشت به سایت می‌توانید از بسته های انتخاب شده استفاده کنید.</span>
          </p>
          <Button
            color='green'
            colorWeight={400}
            content='اتصال به درگاه پرداخت'
            onClick={handleConfirm}
            className='my-2 mx-auto'
          />
        </>
      )}
      <p>
        <span>و با فشردن دکمه </span>
        <span className='font-medium'>قرمز رنگ</span>
        <span> زیر می‌توانید به صفحه فروشگاه بازگشته و بسته‌های انتخابی خود را ویرایش نمایید.</span>
      </p>
      <Button
        color='red'
        colorWeight={400}
        content='بازگشت به فروشگاه'
        onClick={() => navigate(-1)}
        className='my-2 mx-auto'
      />
    </Segment>
  );
}

export default Order;
